import * as React from 'react';
import { useEffect, useState  } from 'react';
import { Box, Grid } from '@mui/material';
import { THREE_D_VIEW_LAYOUT, TOP_VIEW_LAYOUT, RED_GREEN_VIEW_LAYOUT, YELLOW_BLUE_VIEW_LAYOUT, RESET_THREE_D_VIEW_LAYOUT, CONFIG } from "../../../utils/graph-layouts";
import { Graph } from '../graph';
import resetIcon from "./../../../asset/resetGraph.svg";
import { plotlyGamutGraphTreaceData } from "../../../utils/graph-helper";
import { useGraphContext } from '../graphContext';
import { useStoreState, useStoreActions } from 'easy-peasy';
import Legend from '../../common/legend';


const RecycledGamut = ({ gamutData }) => {
  const [data, setData] = useState(gamutData);
  let { pointsVisible } = useGraphContext();  // Use the context
  let evaluationResult = useStoreState((state) => state.evaluationResult);
  let setDownloadReport = useStoreActions(actions => actions.setDownloadReport);
  
    useEffect(() => {
      if(pointsVisible === true) {
        /* Get all LAB points from the state */
        gamutData = plotlyGamutGraphTreaceData(evaluationResult, ['All'], 'recycled');
        setDownloadReport({
          pointsVisible: ['All']
        });
        setData(gamutData);
      } else {
        if(typeof pointsVisible === 'boolean') {
          pointsVisible = false;
        }
         gamutData = plotlyGamutGraphTreaceData(evaluationResult, pointsVisible, 'recycled');
        setDownloadReport({
          pointsVisible: pointsVisible
        });
        setData(gamutData);
      }
    }, [pointsVisible]);

    const resetGraphSize = () => {
      let graphData;
      if(pointsVisible === true) {
        graphData = plotlyGamutGraphTreaceData(evaluationResult, ['All'], 'recycled');
      } else {
        if(typeof pointsVisible === 'boolean') {
          pointsVisible = false;
        }
        graphData = plotlyGamutGraphTreaceData(evaluationResult, pointsVisible, 'recycled');
      }
      setData(graphData);
    };
  

    return(
    <Grid container spacing={0} className='gamutContGrid'>
       <Grid item xs={12} sm={6}  key='0' sx={{ height: '30%' }}> {/* xs={12} for smaller screens */}
          <label for="image-input" className='gamutLable'> 3D View </label>
          <div>
                <img
                  className=''
                  src= { resetIcon }
                  title= "Reset 3D View"
                  alt = "Reset 3D View"
                  style={{ height: '22px', marginLeft: '13%', position: 'absolute',  paddingTop: '2.9%', zIndex: 1, cursor: 'pointer'}}
                  onClick={resetGraphSize}
                />
              </div> 
          <Graph data={data} layout={THREE_D_VIEW_LAYOUT} config={CONFIG} onRelayout='3d'/>
        </Grid>


        <Grid item xs={12} sm={6}  key='1'> {/* xs={12} for smaller screens */}
          <label for="image-input" className='gamutLable' style={{ marginLeft: "150px" }}> Top View </label>
          <Graph data={data} layout={TOP_VIEW_LAYOUT} config={CONFIG}/>
        </Grid>


        <Grid item xs={12} sm={6}  key='2'> {/* xs={12} for smaller screens */}
          <label for="image-input" className='gamutLable'> Red-Green View </label>
          <Graph data={data} layout={RED_GREEN_VIEW_LAYOUT} config={CONFIG}/>
          <Legend name='Recycled Resin' width='25px'  opacity='40%' margin='13.9%'/>
        </Grid>
        <Grid item xs={12} sm={6} key='3'> {/* xs={12} for smaller screens */}
        <label for="image-input" className='gamutLable' style={{ marginLeft: "125px" }}>Yellow-Blue View</label>
          <Graph data={data} layout={YELLOW_BLUE_VIEW_LAYOUT} config={CONFIG}/>
          <Legend name='Virgin Resin' width='28px'  opacity='20%' margin='20px'/>
        </Grid>

    </Grid>
    );
}

export default RecycledGamut;